<template>
	<div id="send-purchase-order-template">
		<div class="quote-requested-success-inner">
		     <div class="error" v-if="badId">
                    <h1>Error</h1>
                    <p>{{badIdMessage}}</p>
                </div>
                <div v-if="survey">
                    <div class="box col md-3">
                        <div class="success-roundel"></div>
                        <div class="quote-requested-success__title">Thank you for your payment.</div>
                        <div class="quote-requested-success__subhead">We'll be in touch to arrange access and we'll be on site as soon as possible! You can track the job progress by logging into your account. If you have a PO number, please insert below.</div>
                            <div class="col md-10 q-req-box-input"><input type="text" v-model="purchaseOrderNumber" placeholder="Send Purchase Order Number"></div>
                            <div class="col md-2 q-req-box-btn"><button class="btn btn-small primary" @click="sendPurchaseOrderNumber">></button></div>
                        <div class="quote-requested-success__img">
                            <img src="@/assets/images/img__payment-success.png" alt="">
                        </div>
                        <button class="btn primary" @click="goToMyAccount">My Account</button>
                    </div>
                </div>
			</div>
	</div>
</template>

<script>

import CreateProgressBar from '../common/Create/CreateProgressBar';

export default {
	data(){
		return {
			purchaseOrderNumber : '',
            badId : false,
            badIdMessage : '',
            quoteReference : '',
            survey : null
		}
	},
	components : {
		appCreateProgressBar : CreateProgressBar
	},
	computed : {
		onGoingSurveys(){
            return this.$store.getters.getOnGoingSurveys;
        }
    },
    watch : {
        onGoingSurveys : function(newVal, oldVal){
            this.checkAndGetSurvey();
        }
    },
	methods : {
		checkAndGetSurvey(){
            let quoteId = this.$route.params.id;
            if(!quoteId){
                this.badId = true
                this.badIdMessage = 'No quote reference passed to the url params'
            } else {
                this.badId = false;
                this.quoteReference = quoteId;
            }

            let correctSurvey = this.onGoingSurveys.filter((surveyData) => {
                return surveyData.survey.quoteReference === quoteId
            })
            
            if(correctSurvey.length > 0){
                this.survey = correctSurvey[0];
                this.badId = false;
                this.badIdMessage = ''; 
               
            } else {
                this.badId = true
                this.badIdMessage = 'Your quote either does not exist or it is not at the correct stage to take payment.'
            }
        },
		goToMyAccount(){
            this.$router.push({path :'/dashboard/surveys/'});
        },
        sendPurchaseOrderNumber(){
            if(!this.purchaseOrderNumber){
                this.$toasted.error('You must enter a purhase order number if you want to submit', {
                    theme: 'bubble',
		            position: 'bottom-center',
		            duration: 5000
                })
                return;
            }

            let data = {
                quoteReference : this.quoteReference,
                data : {
                    payment : {
                        purchaseOrderNumber : this.purchaseOrderNumber
                    }
                }
            }
            this.$store.dispatch('updateSurveyData', data)
            .then((response) => {
            	this.$toasted.clear();
            	if(response.confirmation === 'fail' || response.confirmation === 'validation'){
            		this.$toasted.error(response.message, {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 5000
		            })
		            return;
            	} 

            	if(response.confirmation === 'success'){
            		this.$toasted.success('Your purhcase order number has been saved', {
		                theme: 'bubble',
		                position: 'bottom-center',
		                duration: 7000
                    })
                    this.$router.push({ path : '/dashboard/surveys'})
		            return;
            	}
            })
            .catch((err) => {
            	this.$toasted.clear();
            	this.$toasted.error(err.message, {
		            theme: 'bubble',
		            position: 'bottom-center',
		            duration: 5000
		        })
		        return;
            })
        }
    },
    mounted(){
        this.checkAndGetSurvey()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/SendPurcahseOrder.vue